document.addEventListener("DOMContentLoaded", function() {

    // Výpis nemovitostí
    //==================
    (function () { // kotva ve vypisu nemovitosti
        const nastavitKotvuDoURL = function (ev) {
            let el = ev.currentTarget;
            if(ev.target.matches('.owl-next') || ev.target.matches('.owl-prev') || !el.id)
                return;

            let urlSplit = location.href.split('#');
            location.href = urlSplit[0] + '#' + el.id;
        }

        document.querySelectorAll('.js-estateListItem').forEach((el) => {
            el.addEventListener('click', (ev) => { nastavitKotvuDoURL(ev); });
        })

        document.querySelector('.js-estateList-main').addEventListener('click', (ev) => {
            if(ev.target.matches('.js-estateListItem'))
                nastavitKotvuDoURL(ev);
        });

    }());
});